import styled from 'styled-components'

import { ReactComponent as SketchLogoBlackUnstyled } from 'icons/logo-black.svg'
import ModalUnstyled from 'components/Modal'
import { breakpoint } from 'utils'

import background1x from 'modules/workspace/images/diamond@1x.png'
import background2x from 'modules/workspace/images/diamond@2x.png'

export const Text = styled.p`
  font-size: small;
  color: ${({ theme }) => theme.colors.foreground.secondary[3]};
  display: flex;

  align-items: center;
`

export const SketchLogoBlack = styled(SketchLogoBlackUnstyled)`
  width: 18.78px;
  margin: 0 4px;
`

export const SketchLogoText = styled.span`
  font-weight: 700;
  font-size: medium;
`

export const Modal = styled(ModalUnstyled)`
  background-color: ${({ theme }) => theme.colors.brand.green[100]};
  background-position: right -120px center;

  /* stylelint-disable value-no-vendor-prefix */
  background-image: -webkit-image-set(
    url(${background1x}) 1x,
    url(${background2x}) 2x
  );
  /* stylelint-enable value-no-vendor-prefix */

  background-repeat: no-repeat;

  ${breakpoint('sm')`
    background-position: right -50px center;
  `}

  ${ModalUnstyled.Footer} {
    background: transparent;
  }
`
